import { createSlice } from "@reduxjs/toolkit";
import {
  deleteRole,
  editRole,
  getRoleList,
  // deleteRole,
  // editRole,
  // getRoleById,
  // getRoleList,
  getRolePage, postRole, postRoles,
  // postRole,
  // getRoleByRegionalId,
} from "../action/roleAction";

const initialState = {
  dataRole: [],
  dataRoleList: [],
  dataByIdRole: [],
  dataRoleByRegionalId: [],
  idRole: "",
  state: "",
  isOpenForm: false,
  isLoading: false,
};
const roleSlice = createSlice({
  name: "role",
  initialState,
  reducers: {
    openForm: (state, action) => {
      state.isOpenForm = action.payload.open;
      state.state = action.payload.state;
      if (action.payload.type === 'close') {
        state.dataByIdRole = []
        state.idRole = ''
      }
      if (action.payload.state === "edit") {
        state.dataByIdRole = action.payload.data;
        state.idRole = action.payload.id;
      } else if (action.payload.state === "delete") {
        state.dataByIdRole = action.payload.data;
        state.idRole = action.payload.id;
      }
    },
  },
  extraReducers: {
    [getRolePage.pending]: (state) => {
      state.isLoading = true;
    },
    [getRolePage.fulfilled]: (state, action) => {
      // console.log(action.payload);
      state.dataRole = action.payload.data;
      state.isLoading = false;
    },
    [getRolePage.rejected]: (state) => {
      state.isLoading = false;
    },
    [getRoleList.pending]: (state) => {
      state.isLoading = true
    },
    [getRoleList.fulfilled]: (state, action) => {
      // console.log(action.payload.data);
      state.dataRoleList = action.payload.data
      state.isLoading = false
    },
    [getRoleList.rejected]: (state) => {
      state.isLoading = false
    },
    [postRole.pending]: (state) => {
      state.isLoading = true;
    },
    [postRole.fulfilled]: (state, action) => {
      // console.log(action.payload);
      state.isOpenForm = false;
      state.isLoading = false;
    },
    [postRole.rejected]: (state) => {
      state.isLoading = false;
    },
    // [getRoleById.pending]: (state) => {
    //   state.isLoading = true
    // },
    // [getRoleById.fulfilled]: (state, action) => {
    //   // console.log(action.payload);
    //   state.dataRole = action.payload.data
    //   state.isLoading = false
    // },
    // [getRoleById.rejected]: (state) => {
    //   state.isLoading = false
    // },
    // [getRoleByRegionalId.pending]: (state) => {
    //   state.isLoading = true
    // },
    // [getRoleByRegionalId.fulfilled]: (state, action) => {
    //   // console.log(action.payload)
    //   state.dataRoleByRegionalId = action.payload.data
    //   state.isLoading = false
    // },
    // [getRoleByRegionalId.rejected]: (state) => {
    //   state.isLoading = false
    // },
    [editRole.pending]: (state) => {
      state.isLoading = true
    },
    [editRole.fulfilled]: (state, action) => {
      state.isOpenForm = false
      state.isLoading = false
      state.dataByIdRole = []
      state.idRole = 0
    },
    [editRole.rejected]: (state) => {
      state.isLoading = false
    },
    [deleteRole.pending]: (state) => {
      state.isLoading = true
    },
    [deleteRole.fulfilled]: (state, action) => {
      state.isOpenForm = false
      state.isLoading = false
      state.dataByIdRole = []
      state.idRole = 0
    },
    [deleteRole.rejected]: (state) => {
      state.isLoading = false
    },
  },
});

export const { openForm } = roleSlice.actions;
export default roleSlice.reducer;
